// client/src/pages/admin/assigment/AddAssignmentRow.tsx
import React from 'react';
import NameSearch from '../../../components/search/NameSearch';
import { NewAssignmentSelection } from '../../../types/assignment/NewAssignmentSelection';
import Input from '../../../components/inputs/Input';
import { focusNextInput } from '../../../utils/focusNextInput';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';
import { employeeCodeComparator } from '../../../utils/employeeCodeComparator';

type Props = {
  selected: NewAssignmentSelection;
  setSelected: React.Dispatch<React.SetStateAction<NewAssignmentSelection>>;
  onAddSubmitButtonClick: () => void;
  onSubmitCancelButtonClick: () => void;
};

const AddAssignmentRow: React.FC<Props> = ({
  selected,
  setSelected,
  onAddSubmitButtonClick,
  onSubmitCancelButtonClick,
}) => {
  // ボタンのキーボード遷移用だけ保持（初回フォーカス処理は撤去）
  const inputsRef = React.useRef<(HTMLInputElement | HTMLButtonElement)[]>([]);

  return (
    <>
      {/* 社員コード（自動表示・編集不可） */}
      <td>
        <Input
          value={selected.code ?? ''}
          disabled
          placeholder="自動入力"
          className="bg-white"
        />
      </td>

      {/* 氏名のサジェスト入力（中央寄せ＋幅固定＋初回フォーカス） */}
      <td>
        <div className="mx-auto" style={{ width: 200 }}>
          <NameSearch
            focusOnMount
            sortComparator={(a, b) => employeeCodeComparator(a, b)}
            setSelectedId={(id: number) =>
              setSelected((prev) => ({ ...prev, employeeId: id }))
            }
            setSelectedCode={(code: string) =>
              setSelected((prev) => ({ ...prev, code }))
            }
          />
        </div>
      </td>

      <td className="text-center">
        <SubmitAndCancelButton
          onSubmit={onAddSubmitButtonClick}
          onCancel={onSubmitCancelButtonClick}
          submitButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          cancelButtonRef={(el) => {
            if (el && !inputsRef.current.includes(el)) {
              inputsRef.current.push(el);
            }
          }}
          onSubmitKeyDown={(e) => focusNextInput(e, inputsRef, 7)}
          onCancelKeyDown={(e) => focusNextInput(e, inputsRef, 8)}
        />
      </td>
    </>
  );
};

export default AddAssignmentRow;
